<template>
    <div v-wechat-title="title">
        <el-row type="flex" align="middle">
            <el-col :md="9" :lg="6" :xl="5">
                <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
            </el-col>
            <el-col :md="5" :lg="3" :xl="3"> <item-input type="search" placeholder="关键字搜索" v-model="searchValue" class="width-p100"></item-input></el-col>
            <el-col :md="5" :lg="4" :xl="3"> <el-button type="primary" size="mini" @click="query()">查询</el-button> <el-link type="info" size="mini" plain @click="reset">重置</el-link></el-col>
            <el-col :md="5" :lg="11" :xl="13" class="align-right">
            <el-popover placement="bottom" :open-delay="600">
                <el-button size="mini" plain slot="reference">
                    <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                    <span class="hidden-md-and-down">&nbsp;列配置</span>
                </el-button>
                <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 250px; width: max-content">
                    <div class="config-column">
                        <item-input type="checkboxgroup" :options="configColumns" v-model="user_config_columns"></item-input>
                    </div>
                </el-scrollbar>

                <el-divider></el-divider>
                <div style="text-align: right">
                    <el-link type="primary" size="mini" class="margin-right10" @click="SaveUserColumns">保存</el-link>
                </div>
            </el-popover>
            </el-col>
        </el-row>
        <list-view
            ref="surgery-list"
            :datalist="alldata"
            :columns="userListColumn"
            :buttons="buttons"
            :addButton="{ enabled: false }"
            :deleteButton="{ enabled: false }"
            :tableHeight="screenHeight - 150 - 34"
            :updateButton="{ enabled: false }"
            @gotoSurgeryInfo="gotoSurgeryInfo"
            :filterSpan="[16, 5]"
            :fuzzySearch="false"
            :columnConfig="false"
            @extrabutton-click="ExtraButtonClick"
        >
            <template slot="patient_info" slot-scope="{ row }">
                <el-row :title="row.is_history ? `历史导入数据` : null">
                    <el-col :span="1" class="height-p100">
                        <div
                            class="surgery-status-tag"
                            style="height: 80px"
                            :class="row.enum_surgery_status == 30 ? 'bg-danger' : row.enum_surgery_status == 20 || row.enum_surgery_status == 10 ? 'bg-primary' : 'bg-info'"
                        >
                            &nbsp;<br />&nbsp;<br />&nbsp;
                        </div>
                    </el-col>
                    <el-col :span="22" class="padding5 padding-none-v align-left">
                        <div class="ellipsis" :title="`${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no}/${row.bed_no || '--'}床)`">
                            <b>
                                <el-tag :type="row.enum_surgery_type == 1 ? 'danger' : 'primary'" size="mini" v-if="row.enum_surgery_type">{{ row.surgery_type }}</el-tag>
                                <span class="circle fg-red borderd" v-if="row.is_reoperation">再</span>
                                {{ `${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no}/${row.bed_no || '--'}床)` }}
                            </b>
                        </div>
                        <div>
                            <b class="ellipsis">{{ row.surgeries }}</b>
                        </div>
                        <div>
                            <b class="ellipsis">{{ row.diseases }}</b>
                        </div>
                    </el-col>
                    <el-col v-show="row.is_history" :span="1" class="height-p100">
                        <p style="font-size: x-large; font-weight: bold; color: red">i</p>
                    </el-col>
                </el-row>
            </template>
            <template slot="archive_all_quantity" slot-scope="{ row }">
                <div v-if="row.documentAllCount && row.documentAllCount > 0">{{row.archive_quantity}}/{{row.documentAllCount}}</div>
            </template>
            <template slot="surgeon_info" slot-scope="{ row }">
                <div style="width: 90px; white-space: normal">
                    <span>{{ row.surgeon && `(主)${row.surgeon}` }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.surgeon_assistants }}</span>
                </div>
            </template>
            <template slot="anes_doctor_info" slot-scope="{ row }">
                <div style="width: 90px; white-space: normal">
                    <span>{{ row.anes_doctor && `(主)${row.anes_doctor}` }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.anes_assistants }}</span>
                </div>
            </template>
        </list-view>
        <el-pagination
            class="align-left"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageChange"
            @current-change="pageChange"
            :page-sizes="[10, 20, 50, 100, 200]"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            :total="total"
        >
        </el-pagination>
        <cus-dialog class="document-medicalrecord" :title="document.title" :visible.sync="document.dialogFormVisible" width="60%" :footerVisible="false">
            <DocFrame v-if="document.docno > 0" ref="doc" :docno="document.docno" :docbizid="document.docbizid" :surgeryId="surgeryId"></DocFrame>
            <div v-else style="min-height: 600px" v-loading="loading">
                <pdf v-for="i in numPages" :key="i" :src="src" :page="i"></pdf>
            </div>
        </cus-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
import pdf from '@/common/vue-pdf-4.1.0'
import axios from 'axios'
import Qs from 'qs'
export default {
    name: `UnArchiveDocView`,
    components: { pdf },
    props: {},
    data() {
        return {
            title: `未填写/未归档文书患者列表`,
            buttons: [
                {
                    label: `打开文书`,
                    type: `primary`,
                    emit: `gotoSurgeryInfo`,
                    permission: `default`
                }
            ],
            url: {
                area: `medicalrecord`,
                baseURL: `/api/Preoperative/Apply`,
                get: paras => {
                    return this.ReloadListData()
                }
            },
            rdate: [
                this.$moment()
                    .add(-7, `days`)
                    .format(`YYYY/MM/DD`),
                this.$moment()
                    .format(`YYYY/MM/DD`)
            ],
            o_dic_operating_ward_id: undefined,
            dic_operating_room_id: null,
            surgery_status: [10, 20, 30, 40, 50, 60],
            currentPage: 1,
            pageSize: 50,
            total: 0,
            searchValue: ``,
            issetoperatingward: false,
            documentList: [],
            surgeryId: undefined,
            document: {
                title: ``,
                dialogFormVisible: false,
                docno: ``,
                docbizid: ``
            },
            src: undefined,
            numPages: 0,
            loading: false,
            checkedRow: [],
            is_sealed: 0,
            ward_id: undefined,
            permissions: [],
            thisrow: {},
            alldata: [],
            docId: this.$route.query.docId,
            configColumns: [],
            user_config_columns: [],
            user_config_columns2: []
        }
    },
    created() {
        if (!this.docId) {
            this.$message.error(`未配置查询文书`)
            return
        }
        this.query()
    },
    mounted() {
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        // 加载配置列
        this.loadConfigColumns()
        this.configColumnDrop()
    },
    computed: {
        ...mapGetters([`screenHeight`, `screenWidth`, `ward_auth`, `operation_ward_auth`, `business`, `currentUser`, `sys_enums`, `screenWidth`, `screenHeight`, `active_ward`]),
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        columnList() {
            let list = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `custom`,
                    prop: `patient_info`,
                    label: `患者信息卡`,
                    width: `360`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `archiveStatue`,
                    label: `文书状态`,
                    width: `70`,
                    cellstyle: `font-size:25px;color:red`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    width: `120`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`medicalrecord.visit_no`),
                    width: `100`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    width: `60`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    width: `60`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `诊断`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `手术`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anaes_methods`,
                    label: `麻醉方式`,
                    width: `100`,
                    isListable: true
                },

                {
                    //   type: "string",
                    //   prop: "blood",
                    //   label: "血型",
                    //   width:"80",
                    //   isListable: true
                    // }, {
                    //   type: "string",
                    //   prop: "height",
                    //   label: "身高",
                    //   width:"60",
                    //   isListable: true
                    // }, {
                    //   type: "string",
                    //   prop: "weight",
                    //   label: "体重",
                    //   width:"60",
                    //   isListable: true
                    // }, {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `80`,
                    isListable: true,
                    sortable: true,
                    // 自定义排序
                    sortChange: function(that, { a, b, prop, column }) {
                        let order1 = a[`dic_operating_room_order`]
                        if (!order1) return 1
                        let order2 = b[`dic_operating_room_order`]
                        if (!order2) return -1
                        return order1 - order2
                    }
                },
                {
                    type: `select`,
                    prop: `enum_surgery_status`,
                    label: `手术状态`,
                    width: `80`,
                    isListable: true,
                    options: this.sys_enums.SurgeryStatus || []
                },
                {
                    type: `select`,
                    prop: `enum_surgery_type`,
                    label: `手术类型`,
                    width: `80`,
                    queryable: true,
                    options: this.sys_enums.Enum_SurgeryType || []
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `计划手术时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `in_room_time`,
                    label: `实际手术时间`,
                    width: `120`,
                    isListable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `手术名称`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    queryable: true
                },
                {
                    type: `custom`,
                    prop: `surgeon_info`,
                    label: this.T(`medical_record.plan_surgeon`),
                    width: `90`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: this.T(`medical_record.plan_surgeon`),
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: this.T(`medical_record.plan_surgeon_assistants`),
                    queryable: true
                },
                {
                    type: `custom`,
                    prop: `anes_doctor_info`,
                    label: this.T(`medical_record.plan_anes_doctor`),
                    width: `90`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anes_doctor`,
                    label: this.T(`medical_record.plan_anes_doctor`),
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `anes_assistants`,
                    label: this.T(`medical_record.plan_anes_assistants`),
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `equipment_nurse`,
                    label: this.T(`medical_record.plan_equipment_nurse`),
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `circuit_nurse`,
                    label: this.T(`medical_record.plan_circuit_nurse`),
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    isListable: true
                }
            ]
            return list
        },
        userListColumn() {
            let that = this
            if (this.configColumns.length == 0) {
                return this.columnList
            } else if (this.user_config_columns.length == 0) {
                // added by xiaorui,默认如果用户没有配置任何列 则 1.列配置勾选上当前页面所有列 2.展示当前列表上所有列
                that.user_config_columns = that.configColumns.map(c => c.value)
                return this.columnList
            }
            let allcolumn = _.filter(this.columnList, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            return r
        }
    },
    methods: {
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        pageChange() {
            this.ReloadListData()
        },
        query() {
            this.currentPage = 1
            this.ReloadListData()
        },
        reset() {
            this.dic_operating_room_id = null
            this.searchValue = ``
            this.currentPage = 1
            this.ReloadListData()
        },
        ReloadListData() {
            // 更改日期触发更新列表
            let that = this
            that.alldata = []
            let req = that.myaxios.postpagination(`/api/Operation/Home/SurgeryQueryPage?pageIndex=${this.currentPage}&pageSize=${this.pageSize}`, {
                begin: that.rdate[0],
                end: this.$moment(this.rdate[1]).add(1, `days`).format(`YYYY/MM/DD`),
                dic_operating_ward_id: that.dic_operating_ward_id,
                dic_operating_room_id: 0,
                keyword: this.searchValue,
                surgery_type: 0,
                surgery_status: that.surgery_status
            })
            req.then(res => {
                console.log(res.data)
                this.loadInstances(res.data).then(surgerys => {
                    this.total = surgerys.count
                    that.alldata = surgerys
                })
            })
        },
        gotoSurgeryInfo({ row, index }) {
            let menuName = `document2`
            let r = _.find(this.business, t => {
                return t.business_level == `M004` && t.location == menuName
            })
            if (!r) {
                this.$message.error(`患者管理没有配置 ${menuName} 页面,请配置菜单和工作栏`)
            } else {
                let menuInfo = _.cloneDeep(r)
                let rurl = menuInfo.url
                if (rurl) {
                    rurl += rurl.indexOf(`?`) > -1 ? `&` : `?`
                    rurl = `${rurl}&docId=${this.docId}&isOnly=1`
                    menuInfo.url = rurl
                    this.openUrl(menuInfo, row.id)
                } else {
                    console.log(`菜单`, menuInfo)
                    this.$message.error(`请检查患者文书菜单配置`)
                }
            }
        },
        openUrl(menuInfo, surgeryId) {
            let that = this
            console.log(menuInfo)
            let url = (menuInfo && menuInfo.url) || `/`
            // 第三方链接直接弹框打开，不用二次弹框打开
            if (url.indexOf(`source=`) > -1) {
                url = decodeURIComponent(url.split(`source=`)[1])
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${url}surgery_id=${surgeryId}&isOnlyShowMain=true&workbar=${menuInfo.workbar}&record_type=1`
                this.windowOpenUrl(surgeryId, url)
            } else {
                // 本系统页面链接，直接调用患者管理路由加载界面
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${url}surgery_id=${surgeryId}&isOnlyShowMain=true&workbar=${menuInfo.workbar}&record_type=1`
                let routeUrl = this.$router.resolve({
                    path: url
                })
                var w = this.screenWidth - 10
                var h = this.screenHeight - 10
                that.newWindow = window.open(routeUrl.href, ``, `width=${w},height=${h},top=10,left=10`)
                if (!that.windowsOpenLoop) {
                    that.windowsOpenLoop = setInterval(() => {
                        if (that.newWindow.closed) {
                            clearInterval(that.windowsOpenLoop)
                            that.windowsOpenLoop = ``
                            that.ReloadListData() // 重新请求页面数据
                        }
                    }, 1000)
                }
            }
        },
        loadInstances(surgerys) {
            let that = this
            return new Promise((resolve, reject) => {
                console.log(`afterloadSurgerys`)
                console.log(surgerys)
                if (surgerys.length > 0) {
                    let items = []
                    _.map(surgerys, surgery => {
                        items.push({
                            docid: that.docId, issingleton: true, vid: surgery.id
                        })
                    })
                    let objs = {
                        dept: `acis2020`,
                        items: items
                    }
                    // 调用文书获取结果
                    let url = `${this.$root.DOCSERVICE_BASE}/Wth/QueryWTHMainData`
                    axios.post(url, Qs.stringify(objs), Object.assign({
                        emulateJSON: true
                    })).then(res => {
                        if (res.Status == `SUCCESS`) {
                            let contents = res.Content
                            _.map(surgerys, surgery => {
                                let surgerydoc = []
                                surgerydoc = _.filter(contents, item => item.istemplate == `0` && item.vid == surgery.id)
                                surgery[`archiveStatue`] = surgerydoc.length == 0 ? `未填写` : (surgerydoc.every(item => item.archiveddt != ``) ? `已归档` : `未归档`)
                            })
                        }
                        surgerys = _.filter(surgerys, surgery => surgery.archiveStatue != `已归档`)
                        resolve(surgerys)
                    }).catch(e => {
                        console.log(e)
                    })
                }
            })
        },
        loadConfigColumns() {
            let req = this.myaxios.get(`api/AcisSystem/SystemServer/GetColumnConfig?tableName=api_Preoperative/unArchiveDocView`)
            req.then(data => {
                let lcs = _.orderBy(this.columnList, function(lc) {
                    return _.findIndex(data, { col_name: lc.prop })
                })
                this.configColumns = lcs.map(c => {
                    return { value: c.prop, label: c.label, isListable: c.isListable }
                }).filter(d => {
                    return d.label != `unique` && d.isListable
                })
                this.user_config_columns2 = data && _.filter(data, { enabled: true })
                this.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
            })
        },
        configColumnDrop() {
            // if (!this.columnConfig) return
            const tbody = document.querySelector(`.config-column .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        },
        SaveUserColumns() {
            let uc = this.configColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    table_name: `api_Preoperative/unArchiveDocView`
                }
            })
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                this.ReloadListData()
            }).catch(e => {})
        }
    }
}
</script>
<style  lang="less">
.document-medicalrecord .el-dialog__body {
    padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Medicalrecord/UnArchiveDocView.vue